import clsx from "clsx"
import React from "react"

import Button from "../components/Button"

interface TextProps {
  title: string
  description?: React.ReactNode
  link?: string
  linkClass?: string
  linkText?: string
  wrapperClass?: string
  image?: string | React.ReactNode
}

const ValueProps: React.FC<TextProps> = ({
  title,
  description,
  link,
  linkClass,
  linkText,
  wrapperClass,
  image,
}) => (
  <div className={clsx(wrapperClass, "p-4 mb-8 lg:mb-16")}>
    {image && <div className="mb-4">{image}</div>}
    <h3 className="heading2">{title}</h3>
    {description &&
      (Array.isArray(description) ? (
        description.map((context) => (
          <p className="mt-4 body3" key={context}>
            {context}
          </p>
        ))
      ) : (
        <p className="mt-4 body3">{description}</p>
      ))}
    {link && (
      <Button
        to={link}
        className={clsx("mt-4", linkClass)}
        theme="light"
        variant="tertiary"
      >
        {linkText}
      </Button>
    )}
  </div>
)

export default ValueProps
